import React from "react";
import { Card } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { FaSquarePollHorizontal } from "react-icons/fa6";
import { FaUsers, FaUserFriends, FaMapMarkerAlt, FaCalendarAlt } from "react-icons/fa"; // Icons

const UserDetailsComponent = () => {
  const location = useLocation();

  // Retrieve user data from state
  const user = location.state?.user;

  // If no club data is found, show an error message
  if (!user) {
    return <h2>User Not Found</h2>;
  }

  return (
    <Card className="club-details-card">
      <Card.Body className="d-flex">
        {/* Club Image */}
        <div className="club-logo">
          <img src={user.profilePic} alt={user.username} className="club-image" />
        </div>

        {/* Club Info */}
        <div className="club-info">
          <div className="club-header">
            <h4 className="club-name">{user.username}</h4>
            {/* <FaEllipsisH className="options-icon" /> */}
          </div>
          <p className="club-description">{user.description}</p>

          <div className="user-meta-wraper">
            {/* Club Meta Info */}
            <div className="user-meta">
              <span><FaUsers/>{user.member} followers</span>
              <span><FaUserFriends />{user.following} Following</span>
              <span><FaSquarePollHorizontal /> {user.posts} Posts & {user.polls} Polls</span>
              <span><FaMapMarkerAlt /> {user.location}</span>
              <span><FaCalendarAlt /> Joined on  {user.date}</span>
            </div>

          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default UserDetailsComponent;
